import * as React from "react";
import { DayPicker } from "react-day-picker";
import styles from "./Calendar.module.css";

export type CalendarProps = React.ComponentProps<typeof DayPicker>;

function Calendar({ className, classNames, showOutsideDays = true, ...props }: CalendarProps) {
  return (
    <DayPicker
      showOutsideDays={showOutsideDays}
      className={`${styles.calendar}${className ? ` ${className}` : ''}`}
      classNames={{
        months: styles.months,
        month: styles.month,
        month_caption: styles.monthCaption,
        caption_label: styles.captionLabel,
        nav: styles.nav,
        button_previous: styles.buttonPrevious,
        button_next: styles.buttonNext,
        chevron: styles.chevron,
        month_grid: styles.monthGrid,
        weekdays: styles.weekdays,
        weekday: styles.weekday,
        week: styles.week,
        day: styles.day,
        day_button: styles.dayButton,
        range_start: styles.rangeStart,
        range_end: styles.rangeEnd,
        range_middle: styles.rangeMiddle,
        selected: styles.selected,
        today: styles.today,
        outside: styles.outside,
        hidden: styles.hidden,
        ...classNames,
      }}
      {...props}
    />
  );
}

export { Calendar };
